<template>
  <div>
    <detail :prop="i18n.lbl_destination_asset()" :value="destinationAsset"/>
    <!-- <detail :prop="`${tx.destinationAsset} ${i18n.lbl_wallet()}`" :value="walletId" :copiable="true"/> -->
    <detail :prop="i18n.lbl_wallet()" v-if="wallet" :value="wallet" :copiable="true"/>
    <detail :prop="i18n.lbl_hash()" v-if="hash" :value="hash" :copiable="true"/>
    <detail :prop="i18n.lbl_internal_hash()" v-if="orderId && internalHash" :value="internalHash" :copiable="true"/>
    <detail :prop="i18n.lbl_order_id()" v-if="orderId" :value="orderId" :copiable="true"/>
    <detail :prop="i18n.lbl_order_amount()" v-if="orderAmount" :value="orderAmount"/>
    <detail :prop="i18n.lbl_order_network()" v-if="orderNetwork" :value="orderNetwork"/>
    <detail :prop="i18n.lbl_amount()" :value="`${i18n.c(tx.amount)} ${formatToken}`"/>
    <detail :prop="i18n.lbl_fixed_fee()" :value="`${i18n.c(tx.fixedFee)} ${formatToken}`"/>
    <detail :prop="i18n.lbl_percent_fee()" :value="`${i18n.c(tx.percentFee)} ${formatToken}`"/>
    <detail :prop="i18n.lbl_destination_amount()" :value="`${i18n.c(tx.destinationAmount)} ${formatToken}`"/>
    <!-- <detail v-if="tx.rejectReason.length > 0" :prop="i18n.lbl_reject_reason()" :value="tx.rejectReason"/> -->
    <detail :prop="i18n.lbl_date()" :value="tx.date"/>
    <CheckSignList :id="internalId" :isHistory="true"/>
    <WithdrawalDelay :tx="localList" v-if="showDelay" @close="closeDelay"/>
    <Aml v-if="amlValues && aviliableAml" :score="riskScore" :values="amlValues"/>
  </div>
</template>

<script>
/* eslint-disable */
import Aml from './Aml.vue'
import DetailsMixin from './details.mixin'
import WithdrawalDelay from './WithdrawalDelay.vue'
import {withdrawUSDTService} from '@api/withdraw_usdt.service'
import {ErrorHandler} from '@js/errors/error_handler'
import {CRYPTO_CURRENCYS, AML} from '@utils/consts'
import CurrencyRound from '@com/mixins/currency.round.mixin'
import CheckSignList from '../../../widrawalRequest/CheckSignList.vue'

export default {
  name: 'withdraw-details',
  mixins: [DetailsMixin, CurrencyRound],
  components: {
    Aml,
    WithdrawalDelay,
    CheckSignList
  },
  data() {
    return {
      showDelay: false
    }
  },
  computed: {
    formatToken () {
      return this.tx.asset.startsWith('USDT') ? this.tx.asset.replace(/^USDT/, 'USDT ').replace(/(?<=20)D$/, '') : this.tx.asset
    },
    destinationAsset () {
      return this.tx.destinationAsset.startsWith('USDT') ? this.tx.destinationAsset.replace(/^USDT/, 'USDT ').replace(/(?<=20)D$/, '') 
      : this.tx.destinationAsset
    },
    wallet () {
      if (this.tx._record.external_details) {
        if (this.tx._record.external_details.address && this.tx._record.external_details.address !== '') {
          return this.tx._record.external_details.address
        }
        return false
      }
      return false
    },
    hash () {
      if (this.tx._record.reviewer_details && this.tx._record.reviewer_details.hash) {
        return this.tx._record.reviewer_details.hash
      }
      return false
    },
    internalId () {
      if (this.tx._record.external_details && this.tx._record.external_details.internalId) {
        return this.tx._record.external_details.internalId
      }
      return false
    },
    internalHash () {
      if (this.tx._record.external_details && this.tx._record.external_details.transaction_id) {
        return this.tx._record.external_details.transaction_id
      }
      return false
    },
    orderId () {
      if (this.tx._record.external_details && this.tx._record.external_details.order_id) {
        return this.roundCurrency3(this.tx._record.external_details.order_id)
      }
      return false
    },
    orderNetwork () {
      if (this.tx._record.external_details && this.tx._record.external_details.order_network) {
        return this.tx._record.external_details.order_network
      }
      return false
    },
    orderAmount () {
      if (this.tx._record.external_details && this.tx._record.external_details.order_amount) {
        return `${this.roundCurrency3(this.tx._record.external_details.order_amount)} ${this.tx._record.external_details.order_currency
        ? this.tx._record.external_details.order_currency : ''}`
      }
      return false
    },
    aviliableAml () {
      if (Object.values(CRYPTO_CURRENCYS).includes(this.tx.destinationAsset) || this.tx.destinationAsset.endsWith('20D')) {
        return true
      }
      return false
    },
    totalAmount () {
      return Number(this.withdraw.amount) + Number(Number(this.withdraw.fixedFee) + Number(this.withdraw.percentFee))
    },
    walletId () {
      return this.tx._record.external_details.withdrawalType === 'xpay' ? this.tx._record.external_details.displayName : this.tx.counterparty
    },
    riskScore () {
      const withDelay = this.tx.delay && this.tx.delay !== null ? this.tx.delay.reviewer_details.aml : false
      const noDelay = this.tx._record.reviewer_details && this.tx._record.reviewer_details !== null ? this.tx._record.reviewer_details.aml : false
      if (withDelay || noDelay) {
        return withDelay !== false ? (JSON.parse(withDelay)[0] * 100).toFixed(1) : (noDelay[0] * 100).toFixed(1)
      }
      return null
    },
    amlValues () {
      const withDelay = this.tx.delay && this.tx.delay !== null ? this.tx.delay.reviewer_details.aml : false
      const noDelay = this.tx._record.reviewer_details && this.tx._record.reviewer_details !== null ? this.tx._record.reviewer_details.aml : false
      if (withDelay || noDelay) {
        // eslint-disable-next-line
        let arr = Object.values(withDelay !== false ? JSON.parse(withDelay) : noDelay)
        let obj = AML.reduce((acc, key, index) => {
          acc[key] = arr[index]
          return acc
        }, {})
        let {'Risk score': removed, ...others} = obj
        return others
      }
      return null
    },
    localList: {
      get () {
        return this.tx
      },
      set (val) {
        this.tx.delay = val
      }
    }
  },
  mounted () {
    this.startToggleInterval()
  },
  methods: {
    closeDelay () {
      this.showDelay = false
    },
    async watchDelay () {
      try {
        const { data } = await withdrawUSDTService.getWithdrawalUSDTRequestInfo({internal_id: this.tx._record.external_details.internalId})
        this.localList = data
        if (this.localList.delay) {
          this.showDelay = true
          this.stopToggleInterval()
          return
        }
        this.showDelay = false
      } catch (error) {
        ErrorHandler.processUnexpected(error)
      }
    },
    startToggleInterval () {
        this.watchDelay()
        this.intervalId = setInterval(() => {
          this.watchDelay()
        }, 1000)
      },
    stopToggleInterval () {
      if (this.intervalId) {
        clearInterval(this.intervalId)
        this.intervalId = null
      }
    },
  },
  beforeDestroy () {
    this.stopToggleInterval()
  }
}
</script>



// WEBPACK FOOTER //
// src/vue/app/history/index/components/Details.Withdraw.vue